import React, { Component } from 'react'
import { connect } from 'react-redux'
import windowDimensions from 'react-window-dimensions'
import { fetchThumbIfNeeded } from '../actions'
import { DEFAULT_THUMB } from '../reducers/thumb'
import _ from 'lodash'
import cn from 'classnames'
import { TransitionGroup } from 'react-transition-group'


import { Spinner } from'../images/Spinner';
import { FadeAbsolute, Fade } from './Transitions'

class Thumb extends Component {
	constructor(props) {
		super(props)
		this.state = {
			thumbLoading: _.isEmpty(props.thumb.tiny) ? true : false,
			fullLoading: _.isEmpty(props.thumb.url) ? true : false,
			thisImage: new Image(),
			thisImageTiny: new Image(),
			nextImage: new Image(),
			nextImageTiny: new Image(),
		}
		this.setImages = this.setImages.bind(this)
	}
	componentDidMount() {
		this.props.fetchThumbIfNeeded(this.props.thumbid)
		this.props.nextid && this.props.fetchThumbIfNeeded(this.props.nextid)
		let thisImage = this.state.thisImage,
		    thisImageTiny = this.state.thisImageTiny
		thisImage.onload = () => this.imageLoadedFull()
		thisImageTiny.onload = () => this.imageLoadedTiny()
		this.setState({
			thisImage: thisImage,
			thisImageTiny: thisImageTiny,
		})
	}
	componentWillReceiveProps(nextProps) {
		nextProps.thumbid !== this.props.thumbid && this.props.fetchThumbIfNeeded(nextProps.thumbid)
		nextProps.nextid && nextProps.nextid !== this.props.nextid && this.props.fetchThumbIfNeeded(nextProps.nextid)
		//check dit nog ff todo
		this.props.thumb.url !== nextProps.thumb.url && this.setImages(nextProps)
	}
	setImages(props) {
		let thisImage = this.state.thisImage,
			thisImageTiny = this.state.thisImageTiny,
			nextImage = this.state.nextImage,
			nextImageTiny = this.state.nextImageTiny
		thisImage.src = props.thumb.url
		thisImageTiny.src = props.thumb.tiny
		nextImage.src = props.thumbNext.url
		nextImageTiny.src = props.thumbNext.tiny
		this.setState({
			thisImage: thisImage,
			thisImageTiny: thisImageTiny,
			nextImage: nextImage,
			nextImageTiny: nextImageTiny,
		})
	}
	imageLoadedTiny() {
		this.setState({thumbLoading: false})
	}
	imageLoadedFull() {
		this.setState({fullLoading: false})
	}
	render() {
		const { thumb, fullPage, backgroundImage, parallax} = this.props
		const { thumbLoading, fullLoading } = this.state
		const loadClass = cn('loading-image', {'background-image': backgroundImage, 'image-placeholder': !backgroundImage, 'full-page': fullPage, parallax:parallax})
		const bgClass = cn('background-image', {'full-page': fullPage, parallax: parallax, blur:fullLoading})
		return(
			<TransitionGroup className="image-transition">
				{ thumbLoading ?
					<FadeAbsolute>
						<div className={loadClass}>
							<div className="inner">
								<Spinner/>
							</div>
						</div>
					</FadeAbsolute>
				:
				(!backgroundImage ? 
					<Fade>
						<div className="img-image">
							<TransitionGroup>
								{fullLoading ? 
				                    <FadeAbsolute>
										<img src={thumb.tiny} alt="" className="blur"/>
				                    </FadeAbsolute>
				                    :
				                    <Fade>
										<img src={thumb.url} alt=""/>		             
				                    </Fade>
								}
				            </TransitionGroup>
						</div>
					</Fade>
					:
					<Fade>
						<div className="bg-image">
		            		<TransitionGroup className="bg-image-transition">
								{fullLoading ?
				                    <FadeAbsolute>
										<div className={bgClass} style={{backgroundImage: 'url(' + thumb.tiny + ')'}} />
				                    </FadeAbsolute>
				                    :
				                    <Fade>
										<div className={bgClass} style={{backgroundImage: 'url(' + thumb.url + ')'}} />
				                    </Fade>
								}
				            </TransitionGroup>
						</div>
					</Fade>
				)
			}
			</TransitionGroup>
		)
	}
}

function mapStateToProps(state, ownProps) {
	const theSize = ownProps.size === 'fullscreen-bg' ? (ownProps.windowWidth < 1600 ? 'fullscreen-bg' : 'fullscreen-bg-xl') : ownProps.size
    const thumb = state.thumb[ownProps.thumbid] || state.thumb[DEFAULT_THUMB]
    const thumbNext = state.thumb[ownProps.nextid] || state.thumb[DEFAULT_THUMB]
    const thumbObj = {
    	url: !_.isEmpty(thumb.media_details.sizes[theSize]) ? thumb.media_details.sizes[theSize].source_url : thumb.media_details.sizes.full.source_url,
    	tiny: thumb.media_details.sizes['tiny-preload'].source_url,
    }
    const thumbNextObj = {
    	url: !_.isEmpty(thumbNext.media_details.sizes[theSize]) ? thumbNext.media_details.sizes[theSize].source_url : thumbNext.media_details.sizes.full.source_url,
    	tiny: thumbNext.media_details.sizes['tiny-preload'].source_url,
    }
    return {
        thumb: thumbObj,
        thumbNext: thumbNextObj,
    }
}

export default windowDimensions({
    take: () => ({ windowWidth: window.innerWidth }),
    debounce: onResize => _.debounce(onResize, 100),
})(connect(mapStateToProps, { fetchThumbIfNeeded })(Thumb))


// WEBPACK FOOTER //
// ./src/components/Thumb.js